exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-box[data-v-2bba868a]{width:360px;margin:0 auto;padding-bottom:20px}.switch-link[data-v-2bba868a]{cursor:pointer;display:inline-block;color:#397efd;font-size:14px;margin-top:20px}", ""]);

// exports
